<template>
<div :class="['flex w-full flex-col', { 'my-32': isAuthorPage }]">
    <h2 v-if="isAuthorPage" class="md:text-40 text-28 mb-8 leading-8 sm:leading-[46px] text-blackColor font-trap font-semibold">
        List of author's articles
    </h2>
    <div class="flex gap-6 flex-col flex-wrap lg:flex-row w-full justify-start">
        <div v-for="(article, index) in paginatedArticles" :key="index" class="flex  w-full lg:w-[31%] max-[480px]:flex-col flex-row lg:flex-col justify-between insights p-5">
            <a :href="article.href" class="flex flex-col rounded-xl lg:bg-black h-auto relative">
                <img alt="article image" class="h-[205px] 2xl:h-[248px] rounded-2xl sm:w-[300px] lg:w-auto" :src="article.image" />
                <span class="absolute rounded-br-xl p-1 top-0 text-xs text-blackColor font-semibold left-0 bg-white">{{
                    article.category }}</span>
                <div class="subtract-container-startup bg-transparent absolute top-0">
                    <img alt="subtract" class="bg-transparent" src="../../../images/subtract.svg" />
                </div>
                <div class="bg-transparent absolute top-6">
                    <img alt="subtract" class="bg-transparent" src="../../../images/subtract.svg" />
                </div>
            </a>
            <div class="flex justify-between w-full h-full min-[480px]:ml-8 sm:ml-0 sm:w-1/2 lg:w-auto flex-col">
                <a :href="article.href">
                    <p class="font-bold uppercase text-grayText my-5">
                        {{ article.title }}
                    </p>
                    <p class="text-sm text-grayCase">
                        {{ article.description }}
                    </p>
                </a>
                <div class="flex justify-between mt-8">
                    <div class="flex">
                        <span class="text-gray text-xs">Author</span>
                        <a :href="article.authorHref" rel="noindex follow" class="text-xs text-mainColor ml-2 font-semibold">{{ article.author }}</a>
                    </div>
                    <div class="flex">
                        <span class="text-gray text-xs">Date</span>
                        <span class="text-xs text-grayCase ml-2 font-semibold">{{ article.date }}</span>
                    </div>
                </div>
            </div>
        </div>
        <VuePaginationTw :total-items="reversedArticles.length" :current-page="currentPage" :per-page="itemsPerPage" @page-changed="onPageChanged" :go-button="false" class="flex justify-center w-full mt-8" />
    </div>
</div>
</template>

<script>
import VuePaginationTw from "vue-pagination-tw";
import "vue-pagination-tw/styles";
export default {
    name: "ArticlesPagination",
    components: {
        VuePaginationTw,
    },
    data() {
        const articles = [{
                category: 'Staff Augmentation',
                href: '/blog/staff-augmentation-vs-in-house-recruitment',
                image: '../../images/staff-aug.png',
                title: 'IT Staff Augmentation vs. In-House Recruitment: Costs, Processes, and Benefits',
                description: 'Staff augmentation is an attractive option for growing your tech capacity on time and within budget. With access to top-tier experts worldwide...',
                author: 'Eugene Prystupa',
                date: 'Aug 12, 2024',
                authorHref: '/author'
            }, {
                category: 'Staff Augmentation',
                href: '/blog/staff-augmentation-meaning',
                image: '../../images/it-staff.png',
                title: 'What is Staff Augmentation: Meaning, Definition, and Insights',
                description: "It's not easy to find tech specialists who have exactly the skills you need to complete a project. Especially in today's market, where businesses...",
                author: 'Eugene Prystupa',
                date: 'Aug 15, 2024',
                authorHref: '/author'
            }, {
                category: 'Staff Augmentation',
                image: '../../images/soft-dev.png',
                href: "/blog/staff-augmentation-in-uk",
                title: 'Staff Augmentation in the UK: Achieve an Average of 38% Salary Savings with Nearshore Contractors and Employees',
                description: 'The global tech industry saw over 240,000 job cuts in 2023, with the UK sector similarly impacted by tight budgets and layoffs. This trend continues in 2024...',
                author: 'Eugene Prystupa',
                date: 'Aug 20, 2024',
                authorHref: '/author'
            }, {
                category: 'Staff Augmentation',
                image: '../../images/laptop-staff.png',
                href: '/blog/how-to-choose-a-staff-augmentation-partner',
                title: 'Proven and Unobvious Tips on How to Choose the Right Staff Augmentation Partner',
                description: "If staff augmentation is so beneficial and profitable, why is this software development model met with skepticism? We've heard doubts expressed...",
                author: 'Eugene Prystupa',
                date: 'Aug 26, 2024',
                authorHref: '/author'
            }, {
                category: 'Staff Augmentation',
                image: '../../images/offshore-staff.png',
                href: '/blog/offshore-software-development-rates',
                title: 'Offshore Software Development Rates by Country: A Comprehensive Guide',
                description: "Statistics show that describe their experience 93% of small businesses with outsourcing as positive. It's no wonder since outsourcing is cost-effective...",
                author: 'Eugene Prystupa',
                date: 'Aug 29, 2024',
                authorHref: '/author'
            },
            {
                category: 'Staff Augmentation',
                image: '../../images/dedicated-team-cover.png',
                href: '/blog/hiring-dedicated-development-team',
                title: 'Hiring Dedicated Development Team in 2024: The Ultimate Guide',
                description: "There's a reason why even global corporations like Google and Microsoft embrace dedicated development teams. This outsourcing model...",
                author: 'Eugene Prystupa',
                date: 'Sep 5, 2024',
                authorHref: '/author'
            },
            {
                category: 'Staff Augmentation',
                image: '../../images/augmentation-pros-cons.png',
                href: '/blog/staff-augmentation-vs-outsourcing',
                title: 'Staff Augmentation vs. Project Outsourcing for IT: Pros and Cons',
                description: "When your company needs more IT specialists, the high cost of talent in your home country might push you to look abroad, where salaries are...",
                author: 'Eugene Prystupa',
                date: 'Sep 30, 2024',
                authorHref: '/author'
            },
            {
                category: 'Staff Augmentation',
                href: '/blog/top-10-it-staff-augmentation-companies',
                image: '../../images/staff-aug-top-10.png',
                title: ' Top 10 IT Staff Augmentation Companies in 2024',
                description: 'Over years of working in IT, I’ve seen more and more companies turn to staff augmentation. And that’s not really surprising, given the benefits...',
                author: 'Eugene Prystupa',
                date: 'Dec 10, 2024',
                authorHref: '/author'
            },
            {
                category: 'Staff Augmentation',
                href: '/blog/staff-augmentation-services-in-usa',
                image: '../../images/staff-aug-in-usa.png',
                title: 'Staff Augmentation Services in the USA: Save Up to 75% on Staff Augmentation',
                description: 'IT staff augmentation is an alternative to traditional outsourcing, where companies bring in external, often remote,experts to enhance their team’s...',
                author: 'Eugene Prystupa',
                date: 'Dec 23, 2024',
                authorHref: '/author'
            },
            {
                category: 'Staff Augmentation',
                href: '/blog/comprehensive-guide-to-hiring-mobile-app-developers',
                image: '../../images/comprehensive-guide.png',
                title: 'A Comprehensive Guide to Hiring Mobile App Developers in 2025',
                description: 'So, you have your concept ready, and you’re raring to get to market. But deciding who should build your mobile app presents a dilemma...',
                author: 'Eugene Prystupa',
                date: 'Dec 27, 2024',
                authorHref: '/author'
            },
            {
                category: 'Staff Augmentation',
                href: '/blog/how-much-does-it-cost-to-build-a-website',
                image: '../../images/build-website.png',
                title: 'How Much Does It Cost To Build a Website in 2025? [Guide]',
                description: 'Having a well-designed website is essential for businesses nowadays. However, it can be daunting to work out what this means... ',
                author: 'Eugene Prystupa',
                date: 'Jan 14, 2025',
                authorHref: '/author'
            },
            {
                category: 'Staff Augmentation',
                href: '/blog/how-much-does-it-cost-to-design-mobile',
                image: '../../images/mob-des-cover.png',
                title: 'How Much Does It Cost to Design a Mobile App in 2025? All Factors Revealed',
                description: 'Considering building a mobile app but unsure about the design costs? Let’s simplify the process for you.',
                author: 'Eugene Prystupa',
                date: 'Feb 21, 2025',
                authorHref: '/author'
            },
            {
                category: 'Staff Augmentation',
                href: '/blog/how-to-find-and-hire-dedicated-web-developers',
                image: '../../images/web-dev-cover.png',
                title: 'How to Find and Hire Dedicated Web Developers in 2025',
                description: 'Finding top talent is hard enough, but searching for skilled tech professionals can be even more challenging.',
                author: 'Eugene Prystupa',
                date: 'Feb 27, 2025',
                authorHref: '/author'
            },
            {
                category: 'Staff Augmentation',
                href: '/blog/guide-to-build-erp',
                image: '../../images/notes-cover.png',
                title: 'A Guide to Building an ERP System: Understanding Pricing, Process, and Potential Challenges in 2025',
                description: 'When you run a business, you juggle many tasks—you manage finances, track inventory, and handle personnel and payroll...',
                author: 'Eugene Prystupa',
                date: 'Mar 10, 2025',
                authorHref: '/author'
            },
            {
                category: 'Staff Augmentation',
                href: '/blog/custom-crm-development',
                image: '../../images/crm-cover.png',
                title: 'Custom CRM Development in 2025: Can You Afford It at Low Cost?',
                description: 'Can you make more money thanks to the right CRM system? Absolutely. Research by Salesforce revealed that companies who upgraded their CRM...',
                author: 'Eugene Prystupa',
                date: 'Mar 17, 2025',
                authorHref: '/author'
            },
            {
                category: 'Staff Augmentation',
                href: '/blog/from-concept-to-impact',
                image: '../../images/dedicated-team-cover.png',
                title: 'From Concept to Impact: How Much Does It Cost To Build an Educational App in 2025?',
                description: 'Can you make more money thanks to the right CRM system? Absolutely. Research by Salesforce revealed that companies who upgraded their CRM achieved:',
                author: 'Eugene Prystupa',
                date: 'Mar 27, 2025',
                authorHref: '/author'
            }
        ];
        return {
            articles,
            reversedArticles: articles.slice().reverse(),
            itemsPerPage: window.location.pathname === '/author' ? 3 : 6,
            currentPage: 1,
            isAuthorPage: window.location.pathname === '/author'
        };
    },
    computed: {
        paginatedArticles() {
            const startIndex = (this.currentPage - 1) * this.itemsPerPage;
            const endIndex = startIndex + this.itemsPerPage;
            return this.reversedArticles.slice(startIndex, endIndex);
        },
        totalPages() {
            return Math.ceil(this.reversedArticles.length / this.itemsPerPage);
        },
    },
    methods: {
        onPageChanged(newPage) {
            this.currentPage = newPage;
            if (!this.isAuthorPage) {
                window.scrollTo({
                    top: 200,
                    behavior: 'smooth',
                });
            }
        },
    },
};
</script>
